<script setup lang="ts" generic="MM">
import FormField from '@/components/input/FormField.vue'
import { BaseValidation } from '@vuelidate/core'

const props = defineProps<{
  modelValue?: string
  label?: string
  validation?: BaseValidation
}>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
  blur: []
}>()

function onBlur() {
  props.validation?.$touch()
  emit('blur')
}
</script>

<template>
  <form-field :label="props.label" :validation="props.validation">
    <v-text-field
      v-bind="$attrs"
      :model-value="props.modelValue"
      hide-details
      @update:model-value="(val) => $emit('update:modelValue', val)"
      @blur="onBlur()"
    >
      <template v-for="(_, slot) of $slots" #[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-text-field>
  </form-field>
</template>
